export default __webpack_public_path__ + "static/media/logos.e7c9aff3.png";